<script setup lang="ts">
/**
 * Wrapper local autour de #campaign-ui/CampaignDonationCard.vue.
 * Le composant vit dans le package partagé (source unique). Ce wrapper existe
 * pour que l'auto-import Nuxt (qui ne scanne pas node_modules) trouve le
 * composant sous son nom habituel. Karim 2026-06-21.
 *
 * On dérive le type des props depuis le composant cible et on les relaie
 * explicitement (`v-bind="props"`) : un simple `v-bind="($attrs as any)"` (typé `{}`)
 * ne satisfait pas les props REQUISES du composant typé → erreur vue-tsc.
 */
import CampaignDonationCard from "@donoor/ui/campaign/CampaignDonationCard.vue";
</script>

<template>
  <CampaignDonationCard v-bind="($attrs as any)" />
</template>
